import commonService from '@/service/commonService'

const preLoginMixin = {
  data () {
    return {
      allowInactiveAccountPreLoginOperations:
        this.$appSettings.defaultConfigurations.loginPageScreens
          .allowInactiveAccountPreLoginOperations,
      accountType: 'ST'
    }
  },
  async beforeCreate () {
    if (!localStorage.getItem('countryCode')) {
      const countryCodes = await commonService.getCountryCodes()
      localStorage.setItem('countryCode', JSON.stringify(countryCodes))
    }
  },
  async created () {
    this.accountType = this.IBANAccountFormatEnabled ? 'IB' : 'ST'
  }
}

export default preLoginMixin
